import * as React from 'react';
import {
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {SubTitleLarge} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './panel-loader.css';


export const PanelLoader = ({
  title = '',
  showPanelHeader = true,
  size = 'medium',
  delayMs = 200,
}: {
  title?: React.ReactNode;
  showPanelHeader?: boolean;
  size?: 'medium' | 'large';
  delayMs?: number;
}) => {
  const [shouldShow, setShouldShow] = React.useState(false);
  const timeoutRef = React.useRef<number | null | undefined>(null);

  React.useLayoutEffect(() => {
    // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
    timeoutRef.current = setTimeout(() => {
      setShouldShow(true);
    }, delayMs);

    return () => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [delayMs]);

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      {showPanelHeader && (
        <PanelHeader hideCloseBtn>
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          <SubTitleLarge>{title}</SubTitleLarge>
        </PanelHeader>
      )}
      <PanelBody className={css.localPanelBody}>
        <CircularLoader
          colorToken="colorFillPrimary"
          size={size === 'medium' ? 'medium' : 'large'}
          className={css.loaderContainer}
        />
      </PanelBody>
    </>
  );
};
